import React from "react";
import Cookie from "js-cookie";
import axios from "@/utils/myaxios";
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch,
    Link,
} from "react-router-dom";
import MenuRouter from "@/pages/commom/MenuRouter";
import Header from "@/pages/commom/Header";
import { Modal, Tag, Row } from "antd";
import {
    unionMenu,
    unionVipMenu,
    unionAdminMenu,
    unionAdminServiceMenu,
    unionAdminAccountMenu,
    kpokerUnionMenu,
    kpokerUnionVipMenu,
    kpokerUnionAdminMenu,
    kpokerUnionAdminServiceMenu,
    kpokerUnionAdminAccountMenu,
    superUnionMenu,
    superUnionVipMenu,
    superUnionAdminMenu,
    superUnionAdminServiceMenu,
    superUnionAdminAccountMenu,
    superUnionAdminHouTongMenu,
} from "@/pages/commom/MenuList";
export default class Main extends React.Component {
    // 渲染路由
    renderRoute = (route, langInfo) => {
        return route.redirect ? (
            <Redirect
                to={route.redirect}
                from={route.path}
                exact={route.exact}
                strict={route.strict}
                key={String(Math.random())}
            />
        ) : (
            <Route
                key={String(Math.random())}
                path={route.path}
                title={route.title}
                exact={route.exact}
                strict={route.strict}
                render={(props) => (
                    <route.component title={route.title} {...props} {...langInfo} />
                )}
            />
        );
    }

    render () {
        let routes = [];
        let identityType = Cookie.get("identityType");
        let allowCreate = Cookie.get("allowCreate");
        let identityName, unionType, unionName;
        switch (identityType) {
            case "union":
                identityName = this.props.language["union"];
                unionType = "union";
                unionName = this.props.language["unionTitle"];
                routes = allowCreate === "true"
                    ? unionMenu
                    : unionMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "union_vip":
                identityName = this.props.language["unionVip"];
                unionType = "union";
                unionName = this.props.language["unionTitle"];
                routes = allowCreate === "true"
                    ? unionVipMenu
                    : unionVipMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "union_admin":
                identityName = this.props.language["unionAdmin"];
                unionType = "union";
                unionName = this.props.language["unionTitle"];
                routes = allowCreate === "true"
                    ? unionAdminMenu
                    : unionAdminMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "union_admin_service":
                identityName = this.props.language["unionAdminService"];
                unionType = "union";
                unionName = this.props.language["unionTitle"];
                routes = allowCreate === "true"
                    ? unionAdminServiceMenu
                    : unionAdminServiceMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "union_admin_account":
                identityName = this.props.language["unionAdminAccount"];
                unionType = "union";
                unionName = this.props.language["unionTitle"];
                routes = allowCreate === "true"
                    ? unionAdminAccountMenu
                    : unionAdminAccountMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "kpoker_union":
                identityName = this.props.language["kpokerUnion"];
                unionType = "kpoker_union";
                unionName = this.props.language["kpokerUnionTitle"];
                routes = allowCreate === "true"
                    ? kpokerUnionMenu
                    : kpokerUnionMenu.filter(
                        (item, index) => item.path !== '/table_manage' && item.path !== '/props_consume_record'
                    );
                break;
            case "kpoker_union_vip":
                identityName = this.props.language["kpokerUnionVip"];
                unionType = "kpoker_union";
                unionName = this.props.language["kpokerUnionTitle"];
                routes = allowCreate === "true"
                    ? kpokerUnionVipMenu
                    : kpokerUnionVipMenu.filter(
                        (item, index) => item.path !== '/table_manage' && item.path !== '/props_consume_record'
                    );
                break;
            case "kpoker_union_admin":
                identityName = this.props.language["kpokerUnionAdmin"];
                unionType = "kpoker_union";
                unionName = this.props.language["kpokerUnionTitle"];
                routes = allowCreate === "true"
                    ? kpokerUnionAdminMenu
                    : kpokerUnionAdminMenu.filter(
                        (item, index) => item.path !== '/table_manage' && item.path !== '/props_consume_record'
                    );
                break;
            case "kpoker_union_admin_service":
                identityName = this.props.language["kpokerUnionAdminService"];
                unionType = "kpoker_union";
                unionName = this.props.language["kpokerUnionTitle"];
                routes = allowCreate === "true"
                    ? kpokerUnionAdminServiceMenu
                    : kpokerUnionAdminServiceMenu.filter(
                        (item, index) => item.path !== '/table_manage' && item.path !== '/props_consume_record'
                    );
                break;
            case "kpoker_union_admin_account":
                identityName = this.props.language["kpokerUnionAdminAccount"];
                unionType = "kpoker_union";
                unionName = this.props.language["kpokerUnionTitle"];
                routes = allowCreate === "true"
                    ? kpokerUnionAdminAccountMenu
                    : kpokerUnionAdminAccountMenu.filter(
                        (item, index) => item.path !== '/table_manage' && item.path !== '/props_consume_record'
                    );
                break;
            case "super_union":
                identityName = this.props.language["superUnion"];
                unionType = "super_union";
                unionName = this.props.language["superUnionTitle"];
                routes = allowCreate === "true"
                    ? superUnionMenu
                    : superUnionMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "super_union_vip":
                identityName = this.props.language["superUnionVip"];
                unionType = "super_union";
                unionName = this.props.language["superUnionTitle"];
                routes = allowCreate === "true"
                    ? superUnionVipMenu
                    : superUnionVipMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "super_union_admin":
                identityName = this.props.language["superUnionAdmin"];
                unionType = "super_union";
                unionName = this.props.language["superUnionTitle"];
                routes = allowCreate === "true"
                    ? superUnionAdminMenu
                    : superUnionAdminMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "super_union_admin_service":
                identityName = this.props.language["superUnionAdminService"];
                unionType = "super_union";
                unionName = this.props.language["superUnionTitle"];
                routes = allowCreate === "true"
                    ? superUnionAdminServiceMenu
                    : superUnionAdminServiceMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "super_union_admin_account":
                identityName = this.props.language["superUnionAdminAccount"];
                unionType = "super_union";
                unionName = this.props.language["superUnionTitle"];
                routes = allowCreate === "true"
                    ? superUnionAdminAccountMenu
                    : superUnionAdminAccountMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
            case "super_union_admin_houtong":
                identityName = this.props.language["superUnionAdminHouTong"];
                unionType = "super_union";
                unionName = this.props.language["superUnionTitle"];
                routes = allowCreate === "true"
                    ? superUnionAdminHouTongMenu
                    : superUnionAdminHouTongMenu.filter(
                        (item, index) => item.path !== '/table_manage'
                    );
                break;
        }
        Cookie.set("identityName", identityName, { expires: 0.1 });
        Cookie.set("unionType", unionType, { expires: 0.1 });
        Cookie.set("unionName", unionName, { expires: 0.1 });

        return (
            <Router>
                <div className="main">
                    {/* 左侧菜单 */}
                    <div className="main-menu">
                        <MenuRouter {...this.props} menus={routes} title={unionName} />
                    </div>

                    {/* 右侧页头 */}
                    <div className="main-header">
                        < Header {...this.props} />
                    </div>

                    {/* 右侧内容 */}
                    <div className="main-content">
                        <Switch>
                            {routes.reduce((total, item) => {
                                const routeList = item.children
                                    ? item.children.map((item2) => this.renderRoute(item2, this.props))
                                    : [this.renderRoute(item, this.props)];
                                return [...total, ...routeList];
                            }, [])}
                        </Switch>
                    </div>
                </div>
            </Router>
        );
    }
}
